<template>
  <div>
    <div class="widget-button" @click.stop.prevent="shrink" :class="[windowMode == 'mini' ? 'visible' : 'invisible']">
      <div class="button-chat color-theme-default resetcustom">
        <i class="close-widget-icon"></i>
      </div>
    </div>

    <div class="widget_body">
      <component v-bind:is="screenComponent"></component>
    </div>
  </div>
</template>

<script>
import AskFeedback from '../components/AskFeedbackScreen.vue'
import AskInfo from '../components/AskInfoScreen.vue'
import AskPushNotification from '../components/AskPushNotificationScreen.vue'
import ShowProduct from '../components/ShowProductScreen.vue'
import * as types from '../store/mutation_types'
import store from '../store'

store.commit(types.SET_CUSTOM_SCREEN, { id: 'ask-feedback', screenComponent: AskFeedback })
store.commit(types.SET_CUSTOM_SCREEN, { id: 'ask-info', screenComponent: AskInfo })
store.commit(types.SET_CUSTOM_SCREEN, { id: 'ask-push-notification', screenComponent: AskPushNotification })
store.commit(types.SET_CUSTOM_SCREEN, { id: 'show-product', screenComponent: ShowProduct })

export default {
  name: 'custom-screen',

  data () {
    return {}
  },

  computed: {
    screenComponent () {
      const id = this.$route.params.id || ''
      const html = this.$route.params.html || ''
      if (html) {
        store.commit(types.SET_CUSTOM_SCREEN, { id: id, screenComponent: { template: html } })
      }
      if (!store.state.customScreens[id]) return
      return store.state.customScreens[id]
    },

    windowMode () {
      return store.state.windowMode
    },

    screenId () {
      return this.$route.params.id || ''
    }
  },

  methods: {
    shrink () {
      store.commit(types.SET_LAST_SCREEN_ID, this.screenId)
      this.$router.push({ name: 'chat-button' })
    }
  }
}
</script>
